import { createFileRoute, Link } from '@tanstack/react-router';
import { Bot, ArrowRightLeft, BarChart3, Goal, Radio } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/')({
  component: DashboardPage
});

function DashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
      </div>

      <div className="max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>Quick Links</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid gap-2">
              {/*
                Sideline and Courtside first: they are the two pages opened under time pressure, in
                a stand, one-handed. Everything below is read at a desk.
              */}
              <Link
                to="/custom/sideline"
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <Goal className="size-4" />
                <span className="text-sm font-medium">Sideline</span>
              </Link>
              <Link
                to="/custom/courtside"
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <Radio className="size-4" />
                <span className="text-sm font-medium">Courtside</span>
              </Link>
              <Link
                to="/custom/agents"
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <Bot className="size-4" />
                <span className="text-sm font-medium">Manage Agents</span>
              </Link>
              <Link
                to="/tables/$tableName"
                params={{ tableName: 'orders' }}
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <ArrowRightLeft className="size-4" />
                <span className="text-sm font-medium">View Orders</span>
              </Link>
              <Link
                to="/tables/$tableName"
                params={{ tableName: 'trades' }}
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <BarChart3 className="size-4" />
                <span className="text-sm font-medium">View Trades</span>
              </Link>
              <Link
                to="/custom/trades"
                className="flex items-center gap-2 rounded-md border p-3 transition-colors hover:bg-accent"
              >
                <BarChart3 className="size-4" />
                <span className="text-sm font-medium">Trades Explorer</span>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
